<template>
  <div class="content">
    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/sjzy/sjzy.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-text-wrapper">
          <h1 class="banner-title">特色产业</h1>
        </div>
      </div>
    </div>

    <!-- 特色产业区域 -->
    <div class="featured-section">
      <div class="section-header">

      </div>

      <!-- 产业卡片网格 -->
      <div class="industry-container">
        <!-- 第一行：4个卡片 -->
        <div class="industry-row industry-row-top">
          <a href="https://sta.hnprec.com/zyng/#/" target="_blank" class="industry-card">
            <div class="card-image card-image-1">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">河南种业技术交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>

          <a href="javascript:void(0)" class="industry-card" @click="showUnderConstruction">
            <div class="card-image card-image-2">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">数据要素交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>

          <a href="javascript:void(0)" class="industry-card" @click="showUnderConstruction">
            <div class="card-image card-image-3">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">数字版权及数据知识产权交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>

          <a href="javascript:void(0)" class="industry-card" @click="showUnderConstruction">
            <div class="card-image card-image-4">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">碳达峰碳中和绿色技术交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>
        </div>

        <!-- 第二行：3个卡片 -->
        <div class="industry-row industry-row-bottom">
          <a href="javascript:void(0)" class="industry-card" @click="showUnderConstruction">
            <div class="card-image card-image-5">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">医学科学科技成果交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>

          <a href="javascript:void(0)" class="industry-card" @click="showUnderConstruction">
            <div class="card-image card-image-6">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">中原食品产业数字及成果交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>

          <a href="javascript:void(0)" class="industry-card" @click="showUnderConstruction">
            <div class="card-image card-image-7">
              <div class="card-overlay"></div>
              <div class="card-content">
                <h3 class="card-title">中原中医药科技成果交易服务中心</h3>
                <div class="card-underline"></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  
  
  
  
  export default {
    name: 'tscyContent',
    components: {
  
     
    },
    data(){
      return{
        listnum:0,
        tableData:[],
        tablists:['中原食品产业数字及成果','河南种业技术','数据要素','医学科学科技成果','碳达峰碳中和绿色技术','数字版权及数据知识产权','中原中医药科技成果'],
        tabis:'中原食品产业数字及成果'
      }
    },
    mounted(){
      
    },
    methods:{
      showUnderConstruction() {
        this.$message.info('建设中...')
      },
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
      tabchange(item){
        if(item=='河南种业技术'){
          this.tabis = '中原食品产业数字及成果'
          window.open(` https://sta.hnprec.com/zyng/#/`,
                        '_blank');
                       
        }else{
          this.tabis = item
        }

      }
    }
  }
  </script>
  
  <style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text-wrapper {
  text-align: center;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
}

/* 特色产业区域 */
.featured-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -8px;
  z-index: 10;
  padding-bottom: 80px;
}

.section-header {
  position: relative;
  text-align: center;
  margin-bottom: 70px;
}

.header-title {
  position: relative;
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
  padding-bottom: 16px;
}

.header-title::after {
  content: '';
  position: absolute;
  bottom: -9px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #155DFC;
  border-radius: 2px;
}

/* 产业卡片容器 */
.industry-container {
  width: 1260px;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 产业卡片行 */
.industry-row {
  display: flex;
  gap: 40px;
}

/* 第一行：4个卡片，两端对齐 */
.industry-row-top {
  justify-content: space-between;
}

/* 第二行：3个卡片，居中对齐 */
.industry-row-bottom {
  justify-content: center;
}

.industry-card {
  text-decoration: none;
  display: block;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  width: 285px;
  flex-shrink: 0;
}

.industry-card:hover {
  transform: translateY(-8px);
}

.card-image {
  position: relative;
  width: 100%;
  height: 180px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-image-1 {
  background-image: url('../assets/img/1.png');
}

.card-image-2 {
  background-image: url('../assets/img/2.png');
}

.card-image-3 {
  background-image: url('../assets/img/3.png');
}

.card-image-4 {
  background-image: url('../assets/img/4.png');
}

.card-image-5 {
  background-image: url('../assets/img/5.png');
}

.card-image-6 {
  background-image: url('../assets/img/6.png');
}

.card-image-7 {
  background-image: url('../assets/img/7.png');
}

.industry-card:hover .card-image {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.6) 100%);
  transition: background 0.3s ease;
}

.industry-card:hover .card-overlay {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.7) 100%);
}

.card-content {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  z-index: 2;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.card-underline {
  width: 40px;
  height: 3px;
  background: #3B82F6;
  border-radius: 2px;
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .industry-container {
    width: 100%;
  }
  
  .industry-row-top,
  .industry-row-bottom {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .industry-card {
    width: calc(33.333% - 14px);
    min-width: 250px;
  }
}

@media (max-width: 1024px) {
  .industry-card {
    width: calc(50% - 10px);
    min-width: 200px;
  }
}

@media (max-width: 768px) {
  .industry-row {
    flex-direction: column;
    align-items: center;
  }
  
  .industry-card {
    width: 100%;
    max-width: 400px;
  }
  
  .banner-title {
    font-size: 32px;
  }
}
</style>
  
  